var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-page-print-details',{on:{"init":_vm.handleInit}},[_c('kst-barcode',{attrs:{"value":_vm.details.Barcode,"label":_vm.details.Name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }